export interface WhiteLabelResponse {
  id: number;
  tipoOwner: number;
  ownerId: number;
  slug: string;
  nomeExibicao: string;
  logoLoginArquivoId: number;
  logoLoginUrl?: string | null;
  logoMenuArquivoId: number;
  logoMenuUrl?: string | null;
  ativoFlag: boolean;
  dataCriacao: string;
  dataAtualizacao?: string | null;
}

export interface WhiteLabelAplicavelResponse {
  id: number;
  slug: string;
  nomeExibicao: string;
  logoLoginUrl: string;
  logoMenuUrl: string;
}

export enum TipoOwnerWhiteLabelEnum {
  Parceiro = 1,
  Imobiliaria = 2,
}
